import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from '@env/environment';
import { catchError, map, Observable, of } from 'rxjs';
import { LoginService } from 'src/app/features/login/login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly loginService: LoginService,
  ) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (environment.MOCK_DATA) return true;

    if (window.location.href.includes('code')) return true;

    const token = this.loginService.getAccessToken();
    if (token && !this.loginService.isTokenExpired(token)) return true;

    return this.loginService.refreshToken().pipe(
      map(isAuthenticated => (isAuthenticated ? true : this.router.createUrlTree(['/auth/login']))),
      catchError(() => of(this.router.createUrlTree(['/auth/login']))),
    );
  }
}
